import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

const RemoveProfilePhoto = ({ onShow, onHide, Title }) => {
  return (
    <>
      <Modal show={onShow} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title
            className="fw-bold hstack gap-2"
            style={{ fontSize: 15 }}
          >
            <span>{Title}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-2 section-title d-block">
            <div className="mb-2 text-center">
              <img
                src="https://i.pravatar.cc/40"
                className="rounded-1 w-50 h-100"
                alt="profile"
              />
            </div>
            <p className="text-center">
              Are you sure you want to remove your photo?
              <br /> We’ll replace it with a default Work-bridge avatar.
            </p>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="text-end">
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="outline-primary"
            onClick={onHide}
          >
            Cancel
          </Button>
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="danger"
          >
            Yes, Remove Photo
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RemoveProfilePhoto;
